import axios from "axios";
class Auth {
  constructor() {
    this.access_codes = [];
    this.user = {};
    this.token = window.localStorage.getItem("token");
    let userData = window.localStorage.getItem("user_id");
    this.user_id = userData ? JSON.parse(userData) : null;
    // this.username = window.localStorage.getItem("username");
    if (this.token) {
      axios.defaults.headers.common["Authorization"] = "Bearer " + this.token;
      // this.getUser(this.user_id);
      //this.getAccessCodes(this.user_id);
    }
  }
  login(credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post("login", credentials)
        .then((response) => {
          let token = response.data.token;
          let user = response.data.user;

          this.token = token;
          this.user = user;
          this.user_id = user.id;

          window.localStorage.setItem("token", token);
          window.localStorage.setItem("user_id", JSON.stringify(user.id));
          window.localStorage.setItem("user_name", user.name);
          axios.defaults.headers.common["Authorization"] = "Bearer " + token;

          // window.location.replace("/");
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  check() {
    return !!this.token;
  }
  hasRole(path) {
    if (path != "/" && path != "/load") {
      if (this.access_codes.length > 0) {
        let access = false;
        this.access_codes.forEach(function (code) {
          if (code.path == path) {
            access = true;
            return false;
          }
        });
        if (access) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
    return true;
  }
  clear() {
    localStorage.removeItem("user_id");
    localStorage.removeItem("token");
    // localStorage.removeItem("username");
    this.token = "";
    this.user = "";
    this.user_id = "";
    this.access_codes = [];
  }
  logout() {
    return new Promise((resolve, reject) => {
      this.clear();
      axios
        .post("logout")
        .then(() => {
          resolve("success");
        })
        .catch(({ response }) => {
          reject(response.data.message);
        });
    });
  }
  getUser() {
    let user_id = window.localStorage.getItem("user_id");
    let vm = this;
    return new Promise((resolve, reject) => {
      axios
        .get("get-user")
        .then(function (response) {
          if (user_id != response.data.id) {
            vm.logout();
          }
          vm.user = response.data;
          resolve(vm.user);
        })
        .catch(function (error) {
          console.log(error);
          vm.logout();
          reject(error);
        });
    });
  }

  getAccessCodes(user) {
    let vm = this;
    axios
      .get("pages", {
        params: {
          id: user,
        },
      })
      .then(function (response) {
        vm.access_codes = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }
}

export default Auth;
